import { render, staticRenderFns } from "./AppVibook.vue?vue&type=template&id=4a781192&"
import script from "./AppVibook.vue?vue&type=script&lang=js&"
export * from "./AppVibook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports